<template>
    <comp-9-art-adherence :section="9" :page="62" :nextDisabled="nextDisabled">
        <p>
            Put a checkmark next to any reasons that could make it hard for you to stay committed to taking ART on a regular basis. Feel free to also add some
            reasons of your own.
        </p>
        <v-checkbox
            v-for="barrier in artBarriers"
            :key="barrier.id"
            :label="barrier.text"
            :value="barrier.id"
            v-model="selectedBarriers"
            hide-details
            dense
        ></v-checkbox>
        <v-text-field v-if="showManualResponse" outline single-line type="text" v-model.trim="selectedBarrierResponse"></v-text-field>
    </comp-9-art-adherence>
</template>

<script>
import { sync } from 'vuex-pathify';
import { filter, map, forEach } from 'lodash';

export default {
    data: function() {
        return {
            selectedBarriers: [],
            selectedBarrierResponse: null
        };
    },
    computed: {
        artSelectedBarriers() {
            let artSelectedBarriers = map(filter(this.artBarriers, 'selected'), 'id');

            if (artSelectedBarriers) {
                return artSelectedBarriers;
            } else return [];
        },
        artSelectedBarrierResponse() {
            let userEnteredBarrier = filter(filter(this.artBarriers, 'selected'), 'userEntered');

            if (userEnteredBarrier.length > 0) {
                return userEnteredBarrier[0].response;
            }

            return null;
        },
        showManualResponse() {
            if (filter(filter(this.artBarriers, 'selected'), 'userEntered').length > 0) {
                return true;
            }

            return false;
        },
        artBarriers: sync('section9/artBarriers')
    },
    methods: {
        nextDisabled() {
            if (this.selectedBarriers.length === 0 || (this.showManualResponse && !this.selectedBarrierResponse)) {
                return true;
            } else {
                return false;
            }
        }
    },
    watch: {
        selectedBarriers() {
            forEach(this.artBarriers, o => {
                if (this.selectedBarriers.includes(o.id)) {
                    o.selected = true;

                    if (o.userEntered) {
                        o.response = this.selectedBarrierResponse;
                    }
                } else {
                    o.selected = false;

                    if (o.userEntered) {
                        o.response = null;
                    }
                }
            });
        },
        selectedBarrierResponse() {
            forEach(this.artBarriers, o => {
                if (o.userEntered && o.selected) {
                    o.response = this.selectedBarrierResponse;
                }
            });
        }
    },
    mounted() {
        this.selectedBarriers = this.artSelectedBarriers;
        this.selectedBarrierResponse = this.artSelectedBarrierResponse;
    }
};
</script>
